<template>
  <div>
    <transition-group name="list" tag="div">
      <div v-for="(event, index) in events" :key="`${event.id}${index}`">
        <div class="d-flex flex-row p-2">
          <div>
            <a :href="`https://www.hipflaskapp.com/events/${event.id}`" target="_blank">
              <img class="mr-3 event-image" :src="`${event.picture_resizable}?h=142&w=80`" height="71" width="40" :alt="event.name" @load="onImageLoad">
            </a>
          </div>
          <div class="p-2 align-self-center event-time d-none d-sm-block">
            <div>{{ formatStartDate(event.start_time) }}</div>
            <div>{{ formatStartTime(event.start_time) }}</div>
          </div>
          <div class="p-sm-2 align-self-center event-title">
            <div class="font-weight-bold"><a :href="`https://www.hipflaskapp.com/events/${event.id}`" target="_blank">{{ event.name }}</a></div>
            <div class="event-time-small d-sm-none">
              <div>{{ formatStartDate(event.start_time) }} {{ formatStartTime(event.start_time) }}</div>
            </div>
            <span class="font-weight-bold" v-if="event.location">{{ event.location.name }}</span> <span v-if="event.location">{{ event.location.locality }}</span>
          </div>
          <div class="p-2 align-self-center">
            {{ event.ticket_price ? `$${event.ticket_price}` : 'FREE' }}
          </div>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
const _ = require('lodash')
const axios = require('axios')
const moment = require('moment')

export default {
  name: 'GigGuide',
  data() {
    return {
      baseUrl: 'https://api.hipflaskapp.com/events?calendars=515&format=json',
      events: []
    }
  },
  mounted() {
    this.fetchData(this.baseUrl);
  },
  methods: {
    fetchData(url) {
      axios.get(url)
        .then((response) => {
          this.events = _.concat(this.events, response.data.results)
          if (response.data.next) {
            this.fetchData(response.data.next)
          }
        })
    },
    formatStartDate(startTime) {
      return moment(startTime).format('D MMM')
    },
    formatStartTime(startTime) {
      return moment(startTime).format('H:mm A')
    },
    onImageLoad(event) {
      event.srcElement.style.opacity = 1
    }
  }
};
</script>

<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  margin: 0 10px;
}
a {
  color: #42b983;
}
.list-enter-active, .list-leave-active {
  transition: all 1s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.event-time {
  min-width: 100px;
}
.event-title {
  width: 320px;
}
.event-location {
  min-width: 300px;
}
.event-image {
  opacity: 0;
  transition: all 1s;
}
</style>
